
import { defineComponent, computed, ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { IToken } from '@/types'
import { toShowFormated } from '@/composables/useNumbers'

export default defineComponent({
  name: 'TokenOutput',
  components: {
    Menu,
    MenuButton,
    MenuItems,
    MenuItem
  },
  props: {
    title: { type: String, required: true },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    defaultTokenIdx: { type: Number, default: 2 }
  },
  setup(props, { emit }) {
    const store = useStore()

    const tokens = computed(() => store.getters['swap/tokens']).value

    const selectedToken = ref({ ...tokens[props.defaultTokenIdx], amount: 0 })

    const tokenForSearch = ref('')
    const filteredTokens = computed(() => {
      return tokens.filter(
        (el) =>
          el.name.toLowerCase().includes(tokenForSearch.value.toLowerCase()) ||
          el.symbol.toLowerCase().includes(tokenForSearch.value.toLowerCase())
      )
    })
    const balances = computed(() =>
      store.getters['swap/balances'](selectedToken)
    )

    function selectToken(token: IToken): void {
      selectedToken.value = token
    }

    watchEffect(() => {
      emit('handleToken', selectedToken)
    })

    return {
      tokens,
      selectedToken,
      selectToken,
      filteredTokens,
      tokenForSearch,
      balances,
      toShowFormated
    }
  }
})
